// import { makeStyles } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useState } from "react";
import { Img } from "react-image";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import robot from "../../assets/rebrand/nexbot.svg";
import logo from "../../assets/rebrand/nexum-logo.svg";
import Button from "../../shared/components/button/button";
import HistoryArtifacts from "../historyArtifacts/pages/historyArtifacts";
import * as actions from "../../store/verifyJwtTokenAccess/actions";
import * as actionsd from "../../store/historyArtifacts/action";
import { StateSelector } from "../../shared/interfaces/components/landing-page/landing-page.interface";
import axios from "axios";
import ChatWidget from "../chatWidget/ChatWidget";
import { GoogleLoginButton } from "react-social-login-buttons";
import { LoginSocialGoogle, IResolveParams } from "reactjs-social-login";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../../firebaseConfig";

// axios interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // clean session and redirect to main page
      window.sessionStorage.clear();
      window.localStorage.clear();
      window.location.href = "https://control-plane-fe-703087961199.europe-west6.run.app/signin";
    }

    return Promise.reject(error);
  }
);

const POCReact = () => {
  // take query params from URL
  const search = useLocation().search;

  /** add to sessionStorage data from query params */
  // firebase user/admin IdToken
  const idToken = new URLSearchParams(search).get("token") ?? "";

  // firebase user/admin RefreshToken
  const refreshToken = new URLSearchParams(search).get("refreshToken") ?? "";

  // hooks
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [token, setToken] = useState("");
  const [role, setRole] = useState("");
  const [uid, setUid] = useState("");
  const [trial, setTrial] = useState("");
  const [userSubscription, setUserSubscription] = useState("");
  const [trialEnded, setTrialEnded] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [disableChatbot, setDisableChatbot] = useState(false);
  const [contactFormOpen, setContactFormOpen] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showAutoPilot, setShowAutoPilot] = useState(false);
  const [startAutoPilot, setStartAutoPilot] = useState(false);
  const handleTrialEnded = () => {
    setTrialEnded(true);
  };
  // dispatch an action
  const dispatch = useDispatch();

  // reducer data
  const { userDataAccess, isAuthFirebaseToken } = useSelector(
    (state: StateSelector) => ({
      userDataAccess: state.authFirebaseTokenReducer.authFirebaseTokenResponse,
      isAuthFirebaseToken: state.authFirebaseTokenReducer.isAuthFirebaseToken,
    })
  );

  let tag = document.getElementById("idtest");

  // condition for visibility
  if (tag) {
    if (role === "1") {
      tag.style.display = "block";
    } else {
      tag.style.display = "none";
    }
  }

  useEffect(() => {
    // set cookies
    if (idToken !== "") {
      window.sessionStorage.setItem("idToken", idToken);
      const object = JSON.parse(atob(idToken.split(".")[1]));
      window.sessionStorage.setItem("uid", object.user_id);
    }
    // extract cookies
    if (token === "") {
      const tokenValue = window.sessionStorage.getItem("idToken");
      setToken(tokenValue ?? "");
    }

    // testing token received

    if (isAuthFirebaseToken === null && token !== "")
      dispatch(actions.authFirebaseTokenRequest(token));

    // verify status of the auth API request
    if (isAuthFirebaseToken === true && userDataAccess?.uid) {
      const obj = userDataAccess;
      setUid(obj.uid ?? "JEVZyG7f36S8BPNE6kSTryos43t1");
      setRole(userDataAccess.role.toString() ?? "");
      window.sessionStorage.setItem("uid", uid);

      const chatbot = document.documentElement.querySelector("#dfMessenger");
      chatbot?.setAttribute("user-id", uid);

      // renderize script dinamically !!
      if (
        role === "1" &&
        isAuthFirebaseToken ===
          true /* !!userDataAccess && userDataAccess.role === 1 */
      ) {
        setTimeout(() => {
          const script = document.createElement("script");

          script.src =
            "https://www.gstatic.com/dialogflow-console/fast/messenger-cx/bootstrap.js?v=1";
          script.async = true;

          document.head.appendChild(script);

          return () => {
            document.body.removeChild(script);
          };
        }, 500);
        // clear url
        window.history.replaceState(null, "", "/");
      }
    }

    if (uid !== "")
      dispatch(
        actionsd.getArtifactsRequest({
          uid,
          tenantId: idToken,
          trial,
          handleTrialEnded,
          showAlert,
          setShowAlert,
          setDisableChatbot,
          setShowVideo,
          setContactFormOpen,
          contactFormOpen,
          setShowAutoPilot,
          showAutoPilot,
          startAutoPilot,
          setStartAutoPilot,
        })
      );
  }, [
    dispatch,
    idToken,
    isAuthFirebaseToken,
    refreshToken,
    role,
    token,
    uid,
    userDataAccess,
    startAutoPilot,
    setStartAutoPilot,
  ]);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [profile, setProfile] = useState<any>();

  useEffect(() => {
    const storedToken =
      window.sessionStorage.getItem("idToken") ||
      window.localStorage.getItem("idToken");
    if (storedToken) {
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    const uidFromSessionStorage = sessionStorage.getItem("uid");
    if (uidFromSessionStorage) {
      setUid(uidFromSessionStorage);
    }
  }, []);

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      // Cast dell'oggetto user come any per accedere a stsTokenManager
      const accessToken = (user as any).stsTokenManager.accessToken;
      window.sessionStorage.setItem("idToken", accessToken);
      window.sessionStorage.setItem("uid", user.uid);
      window.localStorage.setItem("welcomeAlert", showAlert ? "false" : "true");
      if (user) {
        setTrial("google");
        window.localStorage.setItem("provider", "google");
        setUid(user.uid);
      }
      setIsLoggedIn(true);
      fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/user/saveData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          uid: user.uid,
          displayName: user.displayName,
          emailSocial: user.email,
          lastLogin: user.metadata.lastSignInTime || null,
        }),
        /* JSON.stringify(user) */
      })
        .then((apiResponse) => {})
        .catch((apiError) => {
          console.error("API call error:", apiError);
        });
    } catch (error) {
      console.error("Google login error", error);
    }
  };

  return uid ? (
    <div className={contactFormOpen ? "bodyHomeTableOpenForm" : "bodyHomeTable"}>
      <div className="background-nexum container">
        <div className="row center-xs">
          <div className="col-xs-12" style={{ marginTop: "1rem" }}>
            <img src={logo} alt="Nexum Logo" style={{ bottom: "0", left: "0", width: "200px" }} />
            <h1 style={{ color: "whitesmoke", fontSize: "3.2rem" }}>
              <b style={{ color: "#294992", textShadow: "-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff" }}>
                Nexbot: Your Personal Cloud Architect Designer
              </b>
            </h1>
          </div>
          {role === "" && !isLoggedIn && (
            <div className="login-buttons">
              <button
                className="base-login"
                onClick={() => {
                  window.open(
                    "https://nexum-saas-portal.oa.r.appspot.com/?appCode=lemmughvsxbfl3vnsxo",
                    "_self"
                  );
                } }
              >
                Start chat
              </button>
              <button className="google-login" onClick={handleGoogleLogin}>
                Free Trial
              </button>
            </div>
          )}
        </div>
        {uid && (
          <div>
            <HistoryArtifacts
              handleTrialEnded={handleTrialEnded}
              setShowAlert={setShowAlert}
              showAlert={showAlert}
              trial={trial}
              uid={uid}
              tenantId={idToken}
              setDisableChatbot={setDisableChatbot}
              setShowVideo={setShowVideo}
              setContactFormOpen={setContactFormOpen}
              contactFormOpen={contactFormOpen}
              setShowAutoPilot={setShowAutoPilot}
              showAutoPilot={showAutoPilot}
              setStartAutoPilot={setStartAutoPilot}
              startAutoPilot={startAutoPilot}
            />
            {!trialEnded && !showAlert && (
              <ChatWidget
                setStartAutoPilot={setStartAutoPilot}
                startAutoPilot={startAutoPilot}
                display={showVideo || (showAutoPilot && "none")}
                pointerEvents={disableChatbot && "none"}
                bottom="25px"
                right="40px"
                zIndex={5}
                opacity={disableChatbot && "0.5"}
                setShowAutoPilot={setShowAutoPilot}
              />
            )}
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className="page-container">
      <div className="logo-header">
        <img src={logo} alt="Nexum Logo" />
      </div>
      <div className="content-container">
        <div className="login">
          <p className="title">
            Your <span className="highlighted-title">Personal</span> Cloud Architect Designer
          </p>
          {role === "" && !isLoggedIn && (
            <div className="login-buttons">
            <button
              className="base-login"
              onClick={() => {
                window.open(
                  "https://control-plane-fe-703087961199.europe-west6.run.app/signin",
                  "_self"
                );
              } }
            >
              Start chat
            </button>
            <button className="google-login" onClick={handleGoogleLogin}>
              Free Trial
            </button>
          </div>
          )}
        </div>
        <img src={robot} alt="robot" />
      </div>
      <div className="descriptions">
        <p>Support for Google, AWS, and Azure with automatic conversion features (e.g. GCP→AWS)</p>
        <p>Scan and Import Tool: analyzes existing projects via API/Service Account, reducing risks and migration time</p>
      </div>
    </div>
  );

};

export default POCReact;
